import { useState, useCallback } from 'react';
import { supabase } from '@services/api';

// Mirrors features/copywriting/hooks/useCopyScoring.js: POST to the skill's
// scoring endpoint, real session token from Supabase. The backend maps
// `moduleId` → the real lesson_id and writes progress to
// `user_progress(lesson_id, exercise_order)`.
const API_BASE = import.meta.env.VITE_APP_API_URL || 'http://localhost:3000/api';

export const useStorytellingScoring = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const scoreExercise = useCallback(
    async ({ moduleId, exerciseOrder, userText, sourceMaterial, instruction, goal, scoringCriteria }) => {
      setLoading(true);
      setError(null);
      try {
        const { data: { session } } = await supabase.auth.getSession();
        const token = session?.access_token;

        const res = await fetch(`${API_BASE}/storytelling/score`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
          body: JSON.stringify({
            moduleId,
            exerciseOrder,
            userText,
            sourceMaterial,
            instruction,
            goal,
            scoringCriteria,
          }),
        });

        if (!res.ok) {
          const errData = await res.json().catch(() => ({}));
          throw new Error(errData.error || `Scoring failed (${res.status})`);
        }

        return await res.json();
      } catch (err) {
        setError(err.message);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return { scoreExercise, loading, error };
};

export default useStorytellingScoring;
